class DropDown {
  constructor(data = {}) {
    this.id = data.id || null;
    this.name = data.name || "";
  }
}

export default DropDown;
